import { Stack, Typography } from '@mui/material';

const EmptyState = ({
    title,
    subtitle,
    icon,
    button,
}: {
    title: string;
    subtitle: string;
    icon: React.ReactNode;
    button?: React.ReactNode;
}) => {
    return (
        <Stack spacing={3} justifyContent='center' alignItems='center' sx={{ textAlign: 'center' }}>
            <Stack spacing={1} justifyContent='center' alignItems='center' sx={{ textAlign: 'center' }}>
                {icon}
                <Typography color='primary' variant='subtitle1' fontWeight='bold'>
                    {title}
                </Typography>
                <Typography color='primary.mui.inactive' variant='subtitle1'>
                    {subtitle}
                </Typography>
            </Stack>
            {button && button}
        </Stack>
    );
};

export default EmptyState;
